<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="1280px" @close="close()">
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">작업-노드 결과 목록</div>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="table" :column-default="columnDefault" :data="tableData" :columns="tableColumns" :show-search-tool="showSearchTool" :show-custom-header="true" remote pagination :total="total" @condition-change="loadData()">
      <template slot-scope="scope" slot="result-slot">
        <span><i class="icon-dot" :style="{ backgroundColor: colorObject[scope.row.resultFlag] }"></i></span>
        <!-- <span><i class="far fa-scroll c-pointer" @click.stop="onClickResultButton(scope.row)"></i></span> -->
      </template>
      <template slot-scope="scope" slot="change-slot">
        <span><i class="fas fa-check" :style="{ color: changeFlagColorObject[scope.row.changeFlag] }"></i></span>
      </template>
      <template slot-scope="scope" slot="analysis-slot">
        <span><i class="far fa-search-plus c-pointer" @click.stop="onClickAnalysisButton(scope.row)"></i></span>
      </template>
    </el-table-wrapper>
    <w-execution-result-buffer-popup ref="resultBufferPopup" :selected-result="selectedResult"></w-execution-result-buffer-popup>
    <w-execution-result-analysis-popup ref="resultAnalysisPopup" :selected-result="selectedResult"></w-execution-result-analysis-popup>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault, defaultDetailHeaderColumn } from '@/constants/table';
import AmsResultAPI from '@/api/ams/result';
import WExecutionResultBufferPopup from './ExecutionResultBufferPopup';
import WExecutionResultAnalysisPopup from './ExecutionResultAnalysisPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WExecutionResultDetailPopup',
  components: {
    WExecutionResultBufferPopup,
    WExecutionResultAnalysisPopup,
  },
  props: {
    selectedResultTrigger: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    title() {
      let title = EMPTY_TEXT;
      if (!isNil(this.selectedResultTrigger)) {
        title = `[${this.selectedResultTrigger.triggerName}] 상세 결과`;
      }

      return title;
    },
  },
  data() {
    return {
      selectedResult: null,
      columnDefault,
      total: 0,
      showSearchTool: false,
      colorObject: {
        S: 'rgb(86, 139, 210)',
        F: 'rgb(253, 116, 132)',
      },
      changeFlagColorObject: {
        true: '',
        false: 'rgb(216, 216, 216)',
      },
      tableColumns: [
        {
          prop: 'resultFlag',
          label: '결과',
          width: '70px',
          scopedSlot: 'result-slot',
          filters: [
            {
              text: '성공',
              value: 'S',
            },
            {
              text: '실패',
              value: 'F',
            },
          ],
        },
        {
          prop: 'jobName',
          label: '작업이름',
          searchable: true,
        },
        {
          prop: 'failover',
          label: '실패제어',
          width: '90px',
          filters: [
            {
              text: 'STOP',
              value: 'STOP',
            },
            {
              text: 'CONTINUE',
              value: 'CONTINUE',
            },
          ],
          formatter: defaultFormatter,
        },
        {
          prop: 'nodeName',
          label: '장비이름',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'nodeIp',
          label: '장비IP',
          searchable: true,
          width: '130px',
          formatter: defaultFormatter,
        },
        // {
        //   prop: 'statusFlag',
        //   label: '상태',
        //   searchable: true,
        //   width: '90px',
        //   formatter: this.getStatusFlagName,
        // },
        {
          prop: 'changeFlag',
          label: '변경',
          width: '80px',
          scopedSlot: 'change-slot',
          filters: [
            {
              text: '변경',
              value: '1',
            },
            {
              text: '미변경',
              value: '0',
            },
          ],
          // formatter: this.getStatusFlagName,
        },
        {
          prop: 'startDatetime',
          label: '시작시각',
          width: '130px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'endDatetime',
          label: '종료시각',
          width: '130px',
          formatter: this.getDateFormatter,
        },
        {
          ...defaultDetailHeaderColumn,
          label: '상세보기',
          // width: '60px',
          // align: 'center',
          scopedSlot: 'analysis-slot',
        },
        // {
        //   label: '변경 사항',
        //   width: '60px',
        //   align: 'center',
        //   scopedSlot: 'analysis-slot',
        // },
        // {
        //   label: '수행 결과',
        //   width: '60px',
        //   align: 'center',
        //   scopedSlot: 'result-slot',
        // },
      ],
      tableData: [],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.total = 0;
      this.tableData = [];
    },
    loadData() {
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        triggerExecId: this.selectedResultTrigger.triggerExecId,
      };
      AmsResultAPI.getTriggerExecutionResultDetailList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.total = result.total;
          this.tableData = result.data;
        }
      });
    },
    getStatusFlagName(row, column, value) {
      if (isEqual(value, 'C')) {
        return '완료';
      } else if (isEqual(value, 'I')) {
        return '진행중';
      }
      return '대기';
    },
    getResultFlagName(row, column, value) {
      if (isEqual(value, 'S')) {
        return '성공';
      }
      return '실패';
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    onClickResultButton(row) {
      this.selectedResult = row;
      this.$refs.resultBufferPopup.open();
    },
    onClickAnalysisButton(row) {
      this.selectedResult = row;
      this.$refs.resultAnalysisPopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/popup/ExecutionResultDetailPopup.vue